var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
export var Md2MenuItem = (function () {
    function Md2MenuItem() {
    }
    Md2MenuItem = __decorate([
        Component({selector: '[md2-menu-item]',
            host: {
                'role': 'menuitem'
            },
            template: '<ng-content></ng-content>'
        }), 
        __metadata('design:paramtypes', [])
    ], Md2MenuItem);
    return Md2MenuItem;
}());
//# sourceMappingURL=menu-item.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/menu/menu-item.js
// module id = 771
// module chunks = 4